import styled, {css} from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction:column;
  align-items:flex-start;
  justify-content:space-between;
  flex-wrap:nowrap;
  width: 100%;
  min-height: 100vh;
  color: var(--primary);
  background-color: var(--secondary);
  #qrcode{
    width: 480px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width:100%;
  gap: 2rem;
`;